export default () => ({
	handle: '',
	product: null,
	current_variant: null,
	activeSlide: 1,
	activeThumb: 1,
	quantity: 1,
	sticky_visible: false,
	url: window.location.href,
	variant_input: document.querySelector('.product-variant-id'),
	recipient_checkbox: document.querySelector('.recipient-checkbox'),
	showTax: false,

	get discount() {
		const price = this.current_variant?.price;
		const compare_price = this.current_variant?.compare_at_price;
		if (compare_price) {
			const sale = Math.round(((compare_price - price) * 100) / compare_price);
			return `-${sale} %`;
		} else {
			return '';
		}
	},

	get price() {
		const price = (this.current_variant?.price / 100).toFixed(2).replace('.', ',');
		return price;
	},

	get comparePrice() {
		if (this.current_variant?.compare_at_price) {
			const comparePrice = (this.current_variant?.compare_at_price / 100)
				.toFixed(2)
				.replace('.', ',');
			return comparePrice;
		} else {
			return '';
		}
	},

	get unitPrice() {
		let unit_pice = '';
		const price = this.current_variant?.unit_price;
		const unit = this.current_variant?.unit_price_measurement.reference_unit;
		const value = this.current_variant?.unit_price_measurement.reference_value;
		if (price && unit) {
			unit_pice = `(${(price / 100).toFixed(2)} ${
				window.Shopify.currency.active
			} / ${value}${unit})`;
		}

		return unit_pice;
	},

	get bisTitle() {
		if (this.product?.variants.length > 1) {
			return this.current_variant?.title;
		} else {
			return this.product?.title;
		}
	},

	async getProduct() {
		const url = `${window.Shopify.routes.root}products/${this.handle}?view=get-product-json`;

		const response = await fetch(url);
		if (response.status !== 200) return;
		const product = await response.json();

		this.product = product;
	},

	setDefaultVariant() {
		if (this.product) {
			if (!this.url.includes('variant=')) {
				if (this.product.options[0] === 'Title') {
					this.current_variant = this.product.selected_or_first_available_variant;
				} else if (this.product.variants.length > 0) {
					this.current_variant = this.product.variants[0];
				} else {
					this.current_variant = this.product.selected_or_first_available_variant;
				}
			}
			this.variant_input.value = this.current_variant?.id;
		}
	},

	setVariantFromURL() {
		let variant_id;
		if (this.url.includes('variant=')) {
			const variant_from_url = this.url.split('variant=')[1];
			if (variant_from_url.includes('&')) {
				variant_id = Number(variant_from_url.split('&')[0]);
			} else {
				variant_id = Number(variant_from_url);
			}
			const variant = this.product.variants.find((el) => el.id === variant_id);
			this.current_variant = variant;
			this.variant_input.value = this.current_variant?.id;
		}
	},

	setVariant(title) {
		if (this.product) {
			if (this.product.variants.length < 1) return;
			const variant = this.product.variants.find((el) => el.title === title);
			this.current_variant = variant;
			this.variant_input.value = this.current_variant?.id;
		}
	},

	showForm() {
		const inputs = document.querySelectorAll('.js-input');
		inputs.forEach((input) => {
			if (this.recipient_checkbox.checked) {
				input.disabled = false;
			} else {
				input.disabled = true;
			}
		});
	},

	fetchConfig(type) {
		return {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
		};
	},

	async addToCart() {
		const gift_form = document.querySelector('.product-gift-form');
		const config = this.fetchConfig('javascript');
		config.headers['X-Requested-With'] = 'XMLHttpRequest';
		delete config.headers['Content-Type'];

		const formData = new FormData(gift_form);
		formData.set('quantity', this.quantity);
		formData.append('sections', 'cart-main,cart-drawer-sections');
		config.body = formData;
		const response = await fetch(window.routes.cartAdd, config);
		const result = await response.json();

		if (response.ok) {
			this.$dispatch('cart-update', { cartData: result });
		}
		this.gtmAddToCart();
	},

	async addUpsellToCart(id, config) {
		if (this.current_variant) {
			const productData = {
				id: id,
				quantity: 1,
				sections: 'cart-main,header',
			};

			const response = await fetch(window.routes.cartAdd + '.js', {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: JSON.stringify(productData),
			});

			const data = await response.json();

			if (response.ok) {
				const destinationCartPopup = document.getElementById('cart-popup');
				const sourceCartPopup = new DOMParser()
					.parseFromString(data.sections['header'], 'text/html')
					.getElementById('cart-popup');

				if (destinationCartPopup && sourceCartPopup) {
					destinationCartPopup.innerHTML = sourceCartPopup.innerHTML;
				}

				this.$dispatch('cart-update');
			}

			this.gtmUpsellAddToCart(config);
		}
	},

	openBisPopup() {
		this.$dispatch('open-bis', { id: this.current_variant?.id, title: this.bisTitle });
	},

	enableSticky() {
		const sticky_start = this.$refs.scrollStart.offsetTop;
		const footer = document.querySelector('.footer');
		const sticky_end = footer.offsetTop - footer.offsetHeight * 4;

		if (window.scrollY >= sticky_start && window.scrollY < sticky_end) {
			this.sticky_visible = true;
		} else {
			this.sticky_visible = false;
		}
	},

	getNumberFromString(string) {
		const formated_string = string.match(/\d+/);
		if (formated_string) {
			const nums = Number(formated_string[0]);
			if (nums) {
				return nums;
			}
		} else return '';
	},

	gtmTracking() {
		window.dataLayer = window.dataLayer || [];
		let url = '';
		let collection_handle = '';
		if (this.product.main_category) {
			if (this.product.main_category.includes('&')) {
				collection_handle = this.product.main_category
					.replace(' & ', '-')
					.toLowerCase()
					.replace(' ', '-');
			} else if (this.product.main_category.includes('Root')) {
				collection_handle = 'all';
			} else {
				collection_handle = this.product.main_category.toLowerCase().replace(' ', '-');
			}
		}

		url = `${window.Shopify.routes.root}collections/${collection_handle}`;

		window.dataLayer.push({
			event: 'EEC-ProductDetailView',
			value: (this.current_variant.price / 100).toFixed(2),
			items: [{ id: this.current_variant.sku, google_business_vertical: 'retail' }],
			ecommerce: {
				detail: {
					actionField: { list: this.product.main_category },
					products: [
						{
							id: this.current_variant.sku,
							sku: this.current_variant.sku,
							name: this.product.title,
							price: (this.current_variant.price / 100).toFixed(2),
							brand: 'Brooklyn Soap Company',
							category: this.product.main_category,
							category_path: url,
						},
					],
				},
			},
		});

		setTimeout(function () {
			// Clear the ecommerce data for subsequent hits.
			window.dataLayer.push({ ecommerce: null });
		}, 3);
	},

	gtmAddToCart() {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'EEC-AddToCart',
			value: (this.current_variant.price / 100).toFixed(2),
			ecommerce: {
				currencyCode: window.Shopify.currency.active,
				add: {
					products: [
						{
							id: this.current_variant.sku,
							sku: this.current_variant.sku,
							name: this.product.title,
							price: (this.current_variant.price / 100).toFixed(2),
							brand: 'Brooklyn Soap Company',
							category: this.product.main_category,
							quantity: this.quantity,
						},
					],
				},
			},
			items: [{ id: this.current_variant.sku, google_business_vertical: 'retail' }],
		});

		setTimeout(function () {
			// Clear the ecommerce data for subsequent hits.
			window.dataLayer.push({ ecommerce: null });
		}, 3);
	},

	gtmUpsellAddToCart(config) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'EEC-AddToCart',
			value: config.price,
			ecommerce: {
				currencyCode: window.Shopify.currency.active,
				add: {
					products: [
						{
							id: config.sku,
							sku: config.sku,
							name: config.title,
							price: config.price,
							brand: 'Brooklyn Soap Company',
							category: config.category,
							quantity: 1,
						},
					],
				},
			},
			items: [{ id: config.sku, google_business_vertical: 'retail' }],
		});

		setTimeout(function () {
			// Clear the ecommerce data for subsequent hits.
			window.dataLayer.push({ ecommerce: null });
		}, 3);
	},

	klaviyoTracking() {
		const product_collections = this.product.collections.map((collection) => collection.title);
		const compare_at_price = this.current_variant.compare_at_price
			? (this.current_variant.compare_at_price / 100).toFixed(2)
			: null;
		let _learnq = window._learnq || [];
		let tracking_object = {
			Name: this.product.title,
			ProductID: this.product.id,
			Categories: product_collections,
			ImageURL: this.product.featured_image,
			URL: `${window.location.origin}${this.product.url}`,
			Brand: this.product.vendor,
			Price: (this.current_variant.price / 100).toFixed(2),
			CompareAtPrice: compare_at_price,
		};

		setTimeout(() => {
			_learnq.push(['track', 'Viewed Product', tracking_object]);
			_learnq.push([
				'trackViewedItem',
				{
					Title: tracking_object.Name,
					ItemId: tracking_object.ProductID,
					Categories: tracking_object.Categories,
					ImageUrl: tracking_object.ImageURL,
					Url: tracking_object.URL,
					Metadata: {
						Brand: tracking_object.Brand,
						Price: tracking_object.Price,
						CompareAtPrice: tracking_object.CompareAtPrice,
					},
				},
			]);
		}, 250);
	},

	showTaxPopup() {
		if (window.innerWidth < 1024) {
			this.showTax = true;
		}
	},

	hideTaxPopup() {
		if (window.innerWidth < 1024) {
			this.showTax = false;
		}
	},

	init() {
		this.$watch('handle', () => {
			this.getProduct();
		});

		this.$watch('product', () => {
			this.setDefaultVariant();
			this.setVariantFromURL();
			this.enableSticky();
			this.gtmTracking();
			this.klaviyoTracking();
		});
	},
});
